import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { baseurl } from "../Baseurl";
import logo from "../components/img/logo.jpeg";

const UserLogin = () => {
  const [email, setEmail] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [assigneeId, setAssigneeId] = useState(null);

  const navigate = useNavigate();

  const handleSendOtp = async () => {
    if (!email) {
      Swal.fire("Error", "Please enter a valid email", "error");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(`${baseurl}sendOtpToAssignee`, { email });

      if (res.status === 200) {
        setOtpSent(true);
        setAssigneeId(res.data.assignee_id);
        Swal.fire("Success", "OTP sent to email", "success");
      } else {
        Swal.fire("Error", res.data.message || "Failed to send OTP", "error");
      }
    } catch (err) {
      console.error("Error sending OTP:", err);
      Swal.fire("Error", err.response?.data?.message || "Failed to send OTP", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    if (otp.length !== 6) {
      Swal.fire("Error", "Please enter a valid 6-digit OTP", "error");
      return;
    }

    try {
      const res = await axios.post(`${baseurl}verifyOtp`, {
        email,
        otp
      });

      if (res.status === 200) {
        Swal.fire("Success", "OTP verified successfully", "success");
        localStorage.setItem("assignee_id", res.data.assignee.id);
        localStorage.setItem("assignee_email", res.data.assignee.email);
        localStorage.setItem("assignee_org_id", res.data.assignee.org_id);
        navigate("/user-dashboard");
      } else {
        Swal.fire("Error", res.data.message || "Invalid OTP", "error");
      }
    } catch (err) {
      console.error("OTP verification error:", err);
      Swal.fire("Error", err.response?.data?.message || "OTP verification failed", "error");
    }
  };

  return (
    <div>
      <div className="container d-flex justify-content-center align-items-center vh-100">
        <div>
          {/* Logo */}
          <div className="text-center">
                     <img src={logo} className="img-fluid logo" alt="Bosplan Logo" />
                 </div>

          {/* Header */}
          <div className="mb-3">
            <h3 className="text-dark cl1 h11">User Login</h3>
            <p className="text-muted">Sign in with Email & OTP</p>
          </div>

          {/* Card */}
          <div className="card p-4" style={{ maxWidth: "400px", width: "100%" }}>
            <form onSubmit={handleVerifyOtp}>
              <div className="mb-3 text-start">
                <label htmlFor="email" className="form-label">Email Address</label>
                <input
                  type="email"
                  id="email"
                  className="form-control"
                  placeholder="Enter Your Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={otpSent}
                />
              </div>

              {otpSent && (
                <div className="mb-3 text-start">
                  <label htmlFor="otp" className="form-label">Enter OTP</label>
                  <input
                    type="text"
                    id="otp"
                    className="form-control"
                    placeholder="Enter 6-digit OTP"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                  />
                </div>
              )}

              <div className="mt-3">
                {loading ? (
                  <div className="spinner-container">
                    <div className="spinner"></div>
                  </div>
                ) : (
                  otpSent ? (
                    <button type="submit" className="btn btn-success w-100">Verify & Login</button>
                  ) : (
                    <button type="button" className="btn btn-primary w-100" onClick={handleSendOtp}>Send OTP</button>
                  )
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserLogin;
